import { render, staticRenderFns } from "./LabelProjectsReleasesEditPanel.vue?vue&type=template&id=308fd70f"
import script from "./LabelProjectsReleasesEditPanel.vue?vue&type=script&lang=js"
export * from "./LabelProjectsReleasesEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports